import { FlagsType } from '../SignInModal';

export const SHOW_SIGNIN_MODAL_PARAM = 'mockShowSignInModal';
const PRODUCTION_HOSTNAMES = ['www.bloomberg.com', 'origin.blue.bloomberg.com'];
const STAGING_HOSTNAMES = [
  'origin.red.bloomberg.com',
  'origin.green.bloomberg.com',
  'origin.orange.bloomberg.com',
  'origin.yellow.bloomberg.com',
  'origin.purple.bloomberg.com',
  'origin.staging.bloomberg.com',
];

export const isProduction = (): boolean =>
  PRODUCTION_HOSTNAMES.includes(window.location.hostname);

export const isStaging = (): boolean =>
  STAGING_HOSTNAMES.includes(window.location.hostname);

export const injectScript = (src: string) => {
  const script = document.createElement('script');

  script.src = src;
  script.async = true;
  script.defer = true;

  document.head.appendChild(script);
};

export const getFlags = async (
  queryString = '',
  timeoutMs = 1000
): Promise<FlagsType> => {
  const coordinatorFlagsUrl = `https://coordinator${
    isProduction() ? '' : '-stg'
  }.cm.bloomberg.com/coordination/flags${queryString}`;

  const ctrl = new AbortController();
  const id = setTimeout(() => ctrl.abort(), timeoutMs);

  try {
    const response = await fetch(coordinatorFlagsUrl, {
      method: 'GET',
      signal: ctrl.signal,
    });

    if (!response.ok) {
      throw new Error(
        `HTTP error! status for fetching /coordination/flags from coordinator is : ${response.status}`
      );
    }

    return response.json();
  } catch (e) {
    // Fetch aborts reject with name === 'AbortError'
    if ((e as Error) && (e as Error).name === 'AbortError') {
      throw new Error(
        'Fetching /coordination/flags from coordinator timed out'
      );
    }
    throw e;
  } finally {
    clearTimeout(id);
  }
};

export const isOnboardingPath = (path: string) => {
  /* check for pathname matching
   * /account/onboarding/ (anything after)
   * /account/onboarding (end of path)
   * /account/onboarding? (query string right after it)
   * and only from the beginning of the string
   */

  const isOnboardingInPath = /^\/account\/onboarding(?:\/|\?|$)/.test(path);

  return isOnboardingInPath;
};
